import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://jpwchsbyuyjndatefbov.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impwd2Noc2J5dXlqbmRhdGVmYm92Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyMzg2NDgsImV4cCI6MjA4ODgxNDY0OH0.TjdLsj2iH3-zjzdGVX41qVkmM-nxRY7KLze9SgU1rXE";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
